import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import { motion } from "framer-motion";
import type { VenueData } from "../../types/venues.types";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/Index";

interface VenueFooterProps {
  venueData: VenueData;
}

export const VenueFooter: React.FC<VenueFooterProps> = ({ venueData }) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);
  if (!venueData.created_by && !venueData.last_updated_by) {
    return null;
  }

  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      sx={{
        width: "100%",
        padding: "16px 24px",
        marginTop: "20px",
        backgroundColor: reduxTheme.primary_colors?.[900] || "#f8f8f8",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        borderRadius: "8px",
      }}
    >
      {venueData.created_by && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            alignItems: "center",
          }}
        >
          <Typography
            variant="caption"
            color={reduxTheme.neutral_colors?.[100]}
            sx={{ fontWeight: "medium" }}
          >
            Created By
          </Typography>

          <Tooltip title={venueData.created_by?.email || ""} placement="top">
            <Typography
              variant="body2"
              color={reduxTheme.primary_colors?.[400] || "#fff"}
              sx={{ fontWeight: "bold" }}
            >
              {venueData?.created_by?.first_name}{" "}
              {venueData?.created_by?.last_name}
            </Typography>
          </Tooltip>
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
          alignItems: "center",
        }}
      >
        <Typography
          variant="caption"
          color={reduxTheme.neutral_colors?.[100]}
          sx={{ fontWeight: "medium" }}
        >
          Last Updated By
        </Typography>

        {venueData.last_updated_by &&
        typeof venueData.last_updated_by !== "string" ? (
          <Tooltip
            title={venueData.last_updated_by?.email || ""}
            placement="top"
          >
            <Typography
              variant="body2"
              color={reduxTheme.primary_colors?.[400]}
              sx={{ fontWeight: "bold" }}
            >
              {venueData.last_updated_by?.first_name}{" "}
              {venueData.last_updated_by?.last_name}
            </Typography>
          </Tooltip>
        ) : (
          <Typography
            variant="body2"
            color={reduxTheme.primary_colors?.[400]}
            sx={{ fontWeight: "bold" }}
          >
            —
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default VenueFooter;
